import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
} from '@mui/material';

const cellStyle = {
  border: '1px solid #ccc',
  verticalAlign: 'top',
  padding: '10px',
};

const sectionCellStyle = {
  ...cellStyle,
  fontWeight: 'bold',
  width: 200,
  backgroundColor: '#f5f5f5',
};

const InfoTableDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {/* Frontline Section */}
              <TableRow>
                <TableCell rowSpan={5} sx={sectionCellStyle}>
                  Frontline (Vehicles count)
                </TableCell>
                <TableCell sx={cellStyle}>Used/New Missing Photos</TableCell>
                <TableCell sx={cellStyle}>
                  Used/New Vehicles without photos as of today
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cellStyle}>Used/New Total</TableCell>
                <TableCell sx={cellStyle}>
                  Total number of Used/New Vehicles as of today
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cellStyle}>Used Missing %</TableCell>
                <TableCell sx={cellStyle}>
                  Used Missing Photos / Used Total
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cellStyle}>New Missing %</TableCell>
                <TableCell sx={cellStyle}>
                  New Missing Photos / New Total
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cellStyle}>UC/NC Photos Completed</TableCell>
                <TableCell sx={cellStyle}>
                  Used/New Vehicle Photos completed as of yesterday
                </TableCell>
              </TableRow>

              {/* DD Pro Section */}
              <TableRow>
                <TableCell rowSpan={6} sx={sectionCellStyle}>
                  DD Pro (Services Count)
                </TableCell>
                <TableCell sx={cellStyle}>Department considered</TableCell>
                <TableCell sx={cellStyle}>
                  "Used Car Sales", "New Car Sales"
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cellStyle}>Service Types</TableCell>
                <TableCell sx={cellStyle}>Detail, Delivery</TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cellStyle}>UC Details in Queue</TableCell>
                <TableCell sx={cellStyle}>
                  "Used Vehicle Detail" Services not in Done, Canceled, Deleted
                  and Declined as of Today
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cellStyle}>UC Details Completed</TableCell>
                <TableCell sx={cellStyle}>
                  "Used Vehicle Detail" Services in Done as of Yesterday
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cellStyle}>NC Lot Preps Completed</TableCell>
                <TableCell sx={cellStyle}>
                  "New Vehicle Lot Prep", "New Vehicle Delivery (Lot Prep)"
                  services in Done as of Yesterday
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={cellStyle}>NC Deliveries Completed</TableCell>
                <TableCell sx={cellStyle}>
                  "New Vehicle Delivery", "New Car Delivery" services in Done as
                  of Yesterday
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button variant="contained" onClick={onClose}>
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoTableDialog;
